import ActionTickWithoutFill from './ActionTickWithoutFill';

export default ActionTickWithoutFill;
